import React, { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { Link, Preloader } from 'components';
import DataBlocks from '../DataBlocks';
import Icon from '../Icon';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class ErrorBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  refresh = () => {
    const refreshResult = this.props.refreshAction();

    this.setState({
      isLoading: true,
    });

    if (refreshResult instanceof Promise) {
      Promise.resolve(refreshResult)
        .finally(() => {
          this.setState({
            isLoading: false,
          });
        });
      return;
    }

    this.timeoutId = setTimeout(() => {
      this.setState({
        isLoading: false,
      });
    }, 45000);
  };

  renderErrorContent = () => (
    <>
      <div className={cx('message')}>
        <Icon className={cx('icon')} name="smile-dead" />
        <div className={cx('text')}>
          Что-то пошло не так.
          <br />
          Попробуйте
          {' '}
          <Link onClick={this.refresh}>
            обновить
          </Link>
          <br />
          через минуту
        </div>
        {this.props.children}
      </div>

      <Preloader className={cx('preloader')} size="80" />
    </>
  );

  render() {
    const { isLoading } = this.state;

    if (this.props.refreshType === 'balance') return this.renderErrorContent();

    return (
      <DataBlocks.Block
        className={cx({ isLoading })}
        {...this.props}
        refreshAction={this.refresh}
      >
        {this.renderErrorContent()}
      </DataBlocks.Block>
    );
  }
}

ErrorBlock.propTypes = {
  children: PropTypes.any,
  refreshAction: PropTypes.func,
  refreshType: PropTypes.string,
};

export default ErrorBlock;
